import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { SignUpService } from '@app/core/services/signUp/signUp.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { CustomValidator } from '../../../../shared/validators/custom-validator';
import { SignaturePadComponent } from '@app/shared/components/signature-pad/signature-pad.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-w9-sform',
  templateUrl: './w9-sform.component.html',
  styleUrls: ['./w9-sform.component.css']
})
export class W9SFormComponent implements OnInit {
  signUpForm: FormGroup;
  UserId: any;
  CurrentDate: Date;
  signatureImage: string;

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private signupService: SignUpService,
    private loaderService: LoaderService,
    private notification: NotificationService,
    private dialog: MatDialog) {
    this.UserId = localStorage.getItem('userId');
    this.signUpForm = this.formBuilder.group({
      Name: ['', Validators.compose([Validators.required])],
      BusinessName: [''],
      Individual: [false],
      CCorporation: [false],
      SCorporation: [false],
      Partnership: [false],
      Trust: [false],
      LLC: [false],
      Other: [false],
      OtherText: [''],
      TaxClassification: [''],
      ExepmtPayeeCode: [''],
      EIN: [''],
      FATCACode: [''],
      SSN: [''],
      Address1: ['', Validators.compose([Validators.required])],
      Address2: ['', Validators.compose([Validators.required])],
      RequestorName: [''],
      LAN: [''],
      UserId: [this.UserId],
      Signature: ['', Validators.compose([Validators.required])],
      DateSigned: [new Date(), Validators.compose([Validators.required])]
    }, { validator: CustomValidator(Validators.required, ['SSN', 'EIN']) });
  }

  ngOnInit() {
  }

  get f() {
    return this.signUpForm.controls;
  }

  onCheckboxChange(event, value) {
    if (event.currentTarget.checked) {
      this.signUpForm.value.Individual = false;
      this.signUpForm.value.CCorporation = false;
      this.signUpForm.value.SCorporation = false;
      this.signUpForm.value.Partnership = false;
      this.signUpForm.value.Trust = false;
      this.signUpForm.value.LLC = false;
      this.signUpForm.value.Other = false;
      if (value == "Individual") {
        this.signUpForm.value.Individual = true;
      }
      else if (value == "CCorporation") {
        this.signUpForm.value.CCorporation = true;
      }
      else if (value == "SCorporation") {
        this.signUpForm.value.SCorporation = true;
      }
      else if (value == "Partnership") {
        this.signUpForm.value.Partnership = true;
      }
      else if (value == "Trust") {
        this.signUpForm.value.Trust = true;
      }
      else if (value == "LLC") {
        this.signUpForm.value.LLC = true;
      }
      else if (value == "Other") {
        this.signUpForm.value.Other = true;
      }
    }
    if (!event.currentTarget.checked) {

    }
  }

  fn_OpenSignaturePad() {
    let dialogRef = this.dialog.open(SignaturePadComponent, {
      width: '460px'
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res != undefined && res.Status == true) {
        this.signatureImage = res.SignatureImage;
        this.signUpForm.patchValue({
          Signature: res.SignatureImage
        });
      }
    });
  }

  onSubmit(signUpForm: FormGroup) {
    let signUpDetails = signUpForm.value;
    this.loaderService.show();

    this.signupService.AddW9SDetails(signUpDetails)
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {
          //Lets open the confirmation email has been sent popup
          this.notification.success(res.Message, 'Register');
        } else if (res.StatusCode === 204) {
          this.notification.info(res.Message, 'Info');
        } else {
          this.notification.error(res.Message, 'Error');
        }
        this.loaderService.hide();
      }, err => {
        this.loaderService.hide();
        this.notification.error('An error occured', 'Error');
      });
  };
}
